import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
export function MenuItemDivider() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <hr className="bg-steel-200 mx-0 my-2 h-px border-0" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}